module.exports = __webpack_public_path__ + "media/images/emblems/Melide-coat_of_arms-82eb0e54d5bfabda0ebc98ccc07c0268.svg";